var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 35,
    height: 35,
    transform: "translate(0.247 0.273)",
    fill: "#fff",
    stroke: "black",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-0.247 -0.273)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(0 4.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M19.519,15.131,34.262.124A2.945,2.945,0,0,0,33.475,0H3.634a3.107,3.107,0,0,0-.79.124L17.587,15.131a1.379,1.379,0,0,0,1.93,0Z",
    transform: "translate(-0.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M20.7,18.106a4.219,4.219,0,0,1-2.983,1.266,4.146,4.146,0,0,1-2.985-1.266L.062,3.178A4.085,4.085,0,0,0,0,3.767V24.653A2.823,2.823,0,0,0,2.792,27.5H32.628a2.822,2.822,0,0,0,2.8-2.846V3.767a2.448,2.448,0,0,0-.069-.589L20.7,18.106Z",
    transform: "translate(0 -0.926)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailBlack);
export default __webpack_public_path__ + "static/media/icon_mail-black.0a08b3210713f0cb93dcdef9892ff35f.svg";
export { ForwardRef as ReactComponent };